import { useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000';
// До входа /support (тикеты) недоступен — нет токена, поэтому mailto вместо внутренней страницы.
const SUPPORT_URL = 'mailto:support@referomed.ru';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr('');
    try {
      const r = await axios.post(`${API}/clinic-cabinet/login`, { email, password });
      localStorage.setItem('clinicToken', r.data.access_token);
      localStorage.setItem('clinicName', r.data.name);
      window.location.href = '/dashboard';
    } catch (e) {
      setErr(e?.response?.data?.detail || 'Ошибка входа');
      setBusy(false);
    }
  };

  return (
    <div style={s.page}>
      <form style={s.card} onSubmit={submit}>
        <img src="/refero-logo-vert.svg" alt="Réfero" style={s.logoImg} />
        <div style={s.logoSub}>личный кабинет клиники</div>
        <h2 style={s.title}>Вход в кабинет</h2>
        <label style={s.label}>Email</label>
        <input style={s.input} value={email} onChange={e => setEmail(e.target.value)} autoFocus />
        <label style={s.label}>Пароль</label>
        <input style={s.input} type="password" value={password} onChange={e => setPassword(e.target.value)} />
        {err && <div style={s.err}>{err}</div>}
        <button style={s.btn} type="submit" disabled={busy}>{busy ? 'Вход…' : 'Войти'}</button>
        <div style={s.links}>
          <a href={SUPPORT_URL} style={s.link}>Связаться с техподдержкой</a>
        </div>
      </form>
    </div>
  );
}

const s = {
  page: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#F6F8FB', fontFamily: 'Inter, system-ui, sans-serif' },
  card: { background: '#fff', borderRadius: 16, padding: 36, width: 380, boxShadow: '0 8px 30px rgba(27,43,75,0.08)' },
  logoImg: { width: 150, height: 'auto', display: 'block', margin: '0 auto 6px' },
  logoSub: { color: '#2EC4B6', fontSize: 13, fontWeight: 600, textAlign: 'center', marginBottom: 8 },
  title: { color: '#1B2B4B', fontSize: 18, fontWeight: 600, margin: '8px 0 20px' },
  label: { display: 'block', color: '#64748b', fontSize: 13, margin: '12px 0 6px' },
  input: { width: '100%', boxSizing: 'border-box', border: '1px solid #e2e8f0', borderRadius: 10, padding: '11px 14px', fontSize: 15, outline: 'none' },
  err: { color: '#ef4444', fontSize: 13, marginTop: 12 },
  btn: { width: '100%', marginTop: 20, background: '#2EC4B6', color: '#fff', border: 'none', borderRadius: 10, padding: '12px', fontSize: 15, fontWeight: 600, cursor: 'pointer' },
  links: { display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 10, marginTop: 18 },
  link: { color: '#2EC4B6', textAlign: 'center', fontSize: 13, textDecoration: 'none', fontWeight: 500 },
};
